import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_ContextRule } from '@app/hcs-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_ContextRule } from '../../../_entity.js';
import { Renderer_ContextRuleHeader } from './renderers/Renderer_ContextRuleHeader/Renderer_ContextRuleHeader.js';
import { Editor_ContextRule } from './renderers/Editor_ContextRule/Editor_ContextRule.js';
import './Manager_ContextRule.scss';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
const Editor_ContextRule_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-context-rule', children: [_jsx(Renderer_ContextRuleHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_ContextRule, { editable: props.editable, editMode: props.renderArgs.editMode, isNewContextRule: props.renderArgs.itemId.startsWith('###NEWITEM###') })] });
export const Manager_ContextRule = createWorkHubManager({
    module: ModuleFE_ContextRule,
    dbDef: DBDef_ContextRule,
    defaultItem: { rules: [], excludedVariableIds: [] },
    labelResolver: (item) => item.label ?? 'New Context Rule',
    EditorComponent: Editor_ContextRule_Wrapper,
});
//# sourceMappingURL=Manager_ContextRule.js.map